export default __webpack_public_path__ + "static/media/BDS-1000-X-350.086c5bff.png";